// @flow
import React from "react";
import styled from "styled-components";
import fominLogoWithName from "../../assets/logo/fominLogoWithName.png";
import fominLogoWithoutName from "../../assets/logo/fominLogoWithoutName.png";
import rassvetLogoWithName from "../../assets/logo/rassvetLogoWithName.png";
import rassvetLogoWithoutName from "../../assets/logo/rassvetLogoWithoutName.png";
import cegLogoWithName from "../../assets/logo/cegLogoWithName.png";
import cegLogoWithoutName from "../../assets/logo/cegLogoWithoutName.png";
import { AvailableApplicationFlavors } from "../../utils/getApplicationFlavor";

export const ClinicLogotype = styled.img`
  grid-area: logo;
`;

type IClinicLogo = {
  flavor?: AvailableApplicationFlavors,
  isShowName?: boolean,
  width?: string,
  height?: string,
};

export const ClinicLogo: React.FC<IClinicLogo> = ({
  flavor = AvailableApplicationFlavors.DEFAULT,
  isShowName = false,
  width = "auto",
  height = "90px"
}) => {
  const image = {
    [AvailableApplicationFlavors.DEFAULT]: isShowName ? fominLogoWithName : fominLogoWithoutName,
    [AvailableApplicationFlavors.TELEMED]: isShowName ? fominLogoWithName : fominLogoWithoutName,
    [AvailableApplicationFlavors.SUNRISE]: isShowName ? rassvetLogoWithName : rassvetLogoWithoutName,
    [AvailableApplicationFlavors.CEG]: isShowName ? cegLogoWithName : cegLogoWithoutName
  };

  return <ClinicLogotype src={image[flavor]} width={width} height={height} />;
};
